import { StringEnum, Type } from "@feathersjs/typebox";
import { artccIdSchema, artccList } from "../events.js";
import { LineStringSchema } from "../schemas/geojsonSchema.js";
import { NullableSchema } from "../typebox.js";
export const adaptedRouteType = [
    "AAR",
    "ADAR",
    "ADR",
    "AIRWAY",
    "DP",
    "MILITARY",
    "STAR",
];
export const AdaptedRouteTypeSchema = StringEnum(adaptedRouteType);
export const NasAltitudeRangeSchema = Type.Object({
    upperAltitude: Type.Number(),
    lowerAltitude: Type.Number(),
});
export const CrossingLineSchema = Type.Object({
    ...NasAltitudeRangeSchema.properties,
    id: Type.String(),
    fix: Type.String(),
    transitionLineDistance: Type.Number(),
    geometry: LineStringSchema,
}, { $id: "crossingLine" });
const AircraftClassSchema = Type.Object({
    owner: StringEnum(["NAT", ...artccList]),
    aircraftClassId: Type.String(),
});
const NasAdaptedRouteSchema = Type.Object({
    ...NasAltitudeRangeSchema.properties,
    artccId: artccIdSchema,
    routeString: Type.String(),
    routeType: StringEnum(adaptedRouteType),
    aircraftClasses: Type.Array(AircraftClassSchema),
    order: Type.Number({
        description: "Adapted order route is used to resolve ties" +
            "between competing adapted routes in auto-route assignment" +
            "for a non-IERR route priority." +
            "An order of 1 is the highest order and" +
            "an order of 100000 is the lowest order.",
    }),
    autoRouteLimit: Type.Number(),
    ierrCriteria: Type.Array(Type.Object({
        ierrCriteriaId: Type.String(),
        owningFacility: artccIdSchema,
        routePriority: Type.Number({ description: "same as order for IERR route priority" }),
    })),
}, { $id: "nasAdaptedRoute" });
export const AdrTransitionFixSchema = Type.Object({
    fix: Type.String(),
    fixType: StringEnum(["Implicit", "Explicit", "Append"]),
    index: NullableSchema(Type.Number({
        description: "How the t-fix will be applied to the alphanumerics." +
            "When Append:" +
            "T-Fix is processed by appending to the alphanumerics" +
            "When Explicit:" +
            "T-fix is explicitly in the alphanumerics, which" +
            "will be trimmed to end at the t-fix. Requires" +
            "the TFixIndex element." +
            "When Implicit:" +
            "T-fix is implicitly in the alphanumerics, included" +
            "when a referenced route is expanded. Alphanumerics" +
            "will be trimmed to end at the t-fix. Requires" +
            "the TFixIndex and TFixRoute elements.",
    })),
    route: Type.Optional(Type.String({
        description: "The name of the route which when expanded contains the T-fix. Only applicable for Implicit type.",
    })),
}, { $id: "adrTransitionFix" });
export const AarTransitionFixSchema = Type.Object({
    fix: Type.String(),
    fixType: StringEnum(["Implicit", "Explicit", "Prepend"]),
    index: NullableSchema(Type.Number({
        description: "When Explicit:" +
            "Where the t- fix is in the converted route" +
            "counting null elements.Basically it is the" +
            "number of dots before the route element containing" +
            "the fix + 1(since the route will start with an element)." +
            "When Implicit:" +
            "Where the route, which when expanded contains the" +
            "T - fix, is in the alphanumerics.",
    })),
    route: Type.Optional(Type.String({
        description: "The name of the route which when expanded contains the T-fix. Only applicable for Implicit type.",
    })),
}, { $id: "aarTransitionFix" });
export const NasAdaptedDepartureRouteSchema = Type.Object({
    ...NasAdaptedRouteSchema.properties,
    adrId: Type.String(),
    airportList: Type.Array(Type.String()),
    transitionFixes: Type.Array(AdrTransitionFixSchema),
    crossingLines: Type.Array(CrossingLineSchema),
}, { $id: "nasAdaptedDepartureRoute" });
export const NasAtcPreferredRouteSchema = Type.Object({
    ...NasAltitudeRangeSchema.properties,
    artccId: artccIdSchema,
    name: Type.String(),
    isHidden: Type.Boolean(),
    minimumFix: Type.String(),
    airportList: Type.Array(Type.String()),
    aircraftClasses: Type.Array(AircraftClassSchema),
}, { $id: "nasApr" });
export const NasAdaptedArrivalRouteSchema = Type.Object({
    ...NasAdaptedRouteSchema.properties,
    aarId: Type.String(),
    airportList: Type.Array(Type.String()),
    transitionFixes: Type.Array(AarTransitionFixSchema),
    crossingLines: Type.Array(CrossingLineSchema),
    applicableArtccIds: Type.Array(artccIdSchema),
}, { $id: "nasAdaptedArrivalRoute" });
export const NasAdaptedDepartureArrivalRouteSchema = Type.Object({
    ...NasAdaptedRouteSchema.properties,
    adarId: Type.String(),
    departureAirports: Type.Array(Type.String()),
    arrivalAirports: Type.Array(Type.String()),
}, { $id: "nasAdaptedDepartureArrivalRoute" });
export const NasAppliedAdaptedRouteSchema = Type.Object({
    artccId: artccIdSchema,
    routeId: Type.String(),
    order: Type.Number(),
    routeType: AdaptedRouteTypeSchema,
    routeString: Type.String(),
    transitionFix: Type.Optional(Type.String()),
    transitionFixType: Type.Optional(StringEnum(["Explicit", "Implicit", "Append", "Prepend"])),
    eligible: Type.Boolean(),
});
//# sourceMappingURL=nasAdaptedRoute.js.map